import React from 'react'
// import { useRef, useEffect } from 'react';
import styles from '../../styles/mainContent/Career.module.css';
import utilities from '../../styles/utilities.module.css';
import { timelineEvents } from '../../data/timelineevents';

const Career = () => {
  // Sort events by start date in descending order (most recent first)
  const sortedEvents = [...timelineEvents].sort((a, b) =>
    b.startdate.getTime() - a.startdate.getTime()
  );

  // Format date to 'Month YYYY' format for timeline items
  const formatDate = (date: Date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric'
    }).format(date);
  };

  // Create an event listener to handle the resize event
  const [displayFullTimeline, setDisplayFullTimeline] = React.useState(window.innerWidth > 1025);
  React.useEffect(() => {
    // Initialize on load (not just on resize)
    setDisplayFullTimeline(window.innerWidth > 1025);
    
    const handleResize = () => {
      // Get the size of the screen directly
      const screenWidth = window.innerWidth;
      
      // Set the displayFullTimeline variable based on the screen size
      setDisplayFullTimeline(screenWidth > 1025);
      
      // Print which view is being displayed
      console.log(screenWidth > 1025 ? 'Desktop view' : 'Mobile view');
    };

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    // Call handleResize once on component mount
    handleResize();

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Run once for setup, but the event listener handles subsequent resizes

  // function to build the timeline items for mobile view
  const buildMobileTimelineItems = () => {
    return sortedEvents.map((event) => (
      <div
        key={event.id}
        className={styles.timelineItem}
      >
        <div className={styles.content}>
          <div
            className={styles.dateLocationWrapper}
          >
            <div className={styles.date}>
              {formatDate(event.startdate)}
              {event.enddate ? ` - ${formatDate(event.enddate)}` : ' - Present'}
            </div>
            <div className={styles.location}>{event.location}</div>
          </div>
          <h3 className={styles.title}>{event.title}</h3>
          <p className={styles.description}>{event.description}</p>
        </div>
      </div>
    ));
  }

  // function to build the timeline items for desktop view
  const buildDesktopTimelineItems = () => {
    return sortedEvents.map((event, index) => (
      <div
        key={event.id}
        className={styles.rowContainer}
      >
        {index % 2 !== 0 ? ( // Left side for odd rows.
          <>
            <div className={styles.rowItem}>
              {/* Minor elements hold the data and location content. */}
              {/* Major elements hold the desc, title, etc. */}
              <div className={styles.left}>
                <div className={styles.title}>{event.title}</div>
                <p className={styles.description}>{event.description}
                </p>
              </div>
            </div>

            <div className={styles.rowItem}>
              {/* Minor elements hold the data and location content. */}
              <div className={styles.right}>
                <div className={styles.date}>
                  {formatDate(event.startdate)}
                  {event.enddate ? ` - ${formatDate(event.enddate)}` : ' - Present'}
                </div>
                <div className={styles.location}>{event.location}</div>
              </div>
            </div>
          </>
        ) : ( // Right side for even rows.
          <>
            <div className={styles.rowItem}>
              {/* Minor elements hold the data and location content. */}
              <div className={styles.left}>
                <div className={styles.date}>
                  {formatDate(event.startdate)}
                  {event.enddate ? ` - ${formatDate(event.enddate)}` : ' - Present'}
                </div>
                <div className={styles.location}>{event.location}</div>
              </div>
            </div>
            <div className={styles.rowItem}>
              {/* Major elements hold the desc, title, etc. */}
              <div className={styles.right}>
                <div className={styles.title}>{event.title}</div>
                <p className={styles.description}>
                  {event.description}
                </p>
              </div>
            </div>
          </>
        )}

      </div>
    ));
  }



  return (
    <section id="career" className={utilities.container}>
      {/* Section title. */}
      <div className={styles.subsection}>
        <h2>Career</h2>
      </div>
      {/* Section Contents */}
      <div className={styles.container}>
        <div className={styles.timeline}>
          {displayFullTimeline ? (buildDesktopTimelineItems()) : (buildMobileTimelineItems())}
        </div>
      </div>
    </section>
  );
};

export default Career;